/**
 * Bahasa Indonesia: the default language of kikik.id.
 *
 * This object is the single source of truth for *which* strings exist. The
 * English dictionary is typed against its keys, so a missing translation is a
 * compile error, never a surprise in the browser.
 *
 * Writing rules: short sentences, no assumed Mahjong knowledge, and every term
 * explained the first time a beginner meets it.
 */

export const ID_STRINGS = {
  // ---------- shell ----------
  "app.title": "kikik.id · Mahjong",
  "app.documentTitle": "kikik.id - Mahjong untuk pemula",
  "app.tagline": "Mahjong Bahasa Indonesia untuk pemula: Belajar → Solo → Online",
  "app.footer.set": "136 tile · tanpa bunga, tanpa joker · sistem skor regional sengaja belum dipilih",
  "app.footer.engine": "Satu engine untuk Belajar, Solo dan Online.",

  // ---------- language selector ----------
  "language.label": "Bahasa",
  "language.switchTo": "Ganti bahasa ke {language}",

  // ---------- modes ----------
  "mode.nav": "Mode permainan",
  "mode.belajar.label": "Belajar",
  "mode.belajar.hint": "Tutorial + pelatih",
  "mode.solo.label": "Solo",
  "mode.solo.hint": "Anda + 3 bot",
  "mode.online.label": "Online",
  "mode.online.hint": "Server otoritatif",

  // ---------- players and seats ----------
  "player.you": "Anda",
  "player.bot.south": "Bot Selatan",
  "player.bot.west": "Bot Barat",
  "player.bot.north": "Bot Utara",
  "player.generic": "Pemain {number}",
  "seat.east": "Timur",
  "seat.south": "Selatan",
  "seat.west": "Barat",
  "seat.north": "Utara",

  // ---------- tiles ----------
  "tile.suited": "{rank} {suit}",
  "suit.characters": "Karakter",
  "suit.bamboo": "Bambu",
  "suit.dots": "Lingkaran",
  "suit.winds": "Angin",
  "suit.dragons": "Naga",
  "tile.WIND_EAST": "Angin Timur",
  "tile.WIND_SOUTH": "Angin Selatan",
  "tile.WIND_WEST": "Angin Barat",
  "tile.WIND_NORTH": "Angin Utara",
  "tile.DRAGON_RED": "Naga Merah",
  "tile.DRAGON_GREEN": "Naga Hijau",
  "tile.DRAGON_WHITE": "Naga Putih",
  "tile.listSeparator": ", ",
  "tile.listAnd": " dan ",

  // ---------- melds and claims ----------
  "meld.chow": "Chow (urutan)",
  "meld.pong": "Pong (tiga sama)",
  "meld.kong": "Kong (empat sama)",
  "meld.pair": "Pasangan",
  "claim.chow": "Chow",
  "claim.pong": "Pong",
  "claim.kong": "Kong",
  "claim.ron": "Menang!",
  "claim.pass": "Lewati",

  // ---------- status bar ----------
  "status.turn": "Giliran",
  "status.phase": "Status",
  "status.wall": "Sisa dinding",
  "status.wallShort": "dinding",
  "status.lastDiscard": "Buangan terakhir",
  "status.none": "belum ada",
  "status.ended": "—",
  "status.discardBy": "{tile} oleh {player}",
  "phase.awaiting-draw": "menunggu pengambilan tile",
  "phase.awaiting-discard": "menunggu pembuangan tile",
  "phase.awaiting-claims": "ada klaim atas buangan",
  "phase.ended": "selesai",

  // ---------- table controls ----------
  "table.draw": "Ambil tile",
  "table.win": "Menang!",
  "table.kongFromHand": "Kong dari tangan",
  "table.hint": "Saran",
  "table.hint.ended": "Ronde selesai.",
  "table.hint.claimable": "Ada buangan yang bisa Anda klaim.",
  "table.hint.waitingClaims": "Menunggu keputusan klaim pemain lain...",
  "table.hint.waitingPlayer": "Menunggu {player}...",
  "table.hint.draw": "Ambil satu tile dari dinding.",
  "table.hint.drawing": "Mengambil tile dari dinding...",
  "table.hint.discard": "Klik satu tile di tangan Anda untuk membuangnya.",

  // ---------- your hand ----------
  "hand.title": "Tangan Anda ({count} tile)",
  "hand.ready": "Siap menang! Menunggu {tiles}",
  "hand.discards": "Buangan Anda ({count})",
  "hand.noDiscards": "Belum ada buangan.",
  "hand.discardTile": "Buang {tile}",
  "hand.arrange": "Atur rak",
  "hand.autoSort": "Urut otomatis",
  "hand.sort": "Urutkan",
  "hand.moveHint": "Alt + ← → untuk memindahkan tile",

  // ---------- opponent seats ----------
  "seat.turnBadge": "giliran",
  "seat.claimBadge": "memutuskan klaim",
  "seat.concealed": "{count} tile tertutup",
  "seat.discardsOf": "Buangan {player}",
  "seat.melds": "Set terbuka",

  // ---------- claim bar ----------
  "claims.title": "Klaim buangan",
  "claims.waitingOthers": "Menunggu keputusan pemain lain...",
  "claims.declared": "Sudah menyatakan: {list}",
  "claims.chowHint": "({count} tile dari tangan)",
  "claims.suggested": "disarankan",

  // ---------- coach ----------
  "coach.title": "Pelatih",
  "coach.ask": "Minta saran",
  "coach.follow": "Lakukan saran ini",
  "coach.empty": "Tekan “Minta saran” kapan saja untuk penjelasan langkah.",
  "coach.label.hint": "Saran",
  "coach.label.reason": "Alasan",
  "coach.label.keep": "Pertahankan",
  "coach.label.consider": "Pertimbangkan",
  "coach.label.discard": "Buang",

  "coach.gameOver.headline": "Ronde selesai",
  "coach.gameOver.win": "Pemenang: {player}.",
  "coach.gameOver.draw": "Dinding habis, jadi ronde berakhir seri.",
  "coach.wait.headline": "Tunggu giliran Anda",
  "coach.wait.reason": "Sekarang pemain lain yang bergerak.",
  "coach.none.headline": "Belum ada saran",
  "coach.none.reason": "Tidak ada langkah yang bisa disarankan sekarang.",
  "coach.win.headline": "Menang! Umumkan sekarang",
  "coach.win.reason": "Tangan Anda sudah menjadi 4 set + 1 pasangan.",
  "coach.win.note": "Tekan tombol Menang untuk menyelesaikan ronde.",
  "coach.ron.headline": "Ambil buangan itu: Anda menang!",
  "coach.ron.reason": "{tile} melengkapi tangan Anda menjadi 4 set + 1 pasangan.",
  "coach.ron.note": "Menang dari tile yang dibuang pemain lain disebut ron.",
  "coach.claim.headline": "Ambil {meld}",
  "coach.claim.reason": "Mengambil {tile} membuat tangan Anda lebih dekat: dari {before} menjadi {after}.",
  "coach.claim.note": "Setelah mengambil, Anda langsung membuang satu tile.",
  "coach.pass.headline": "Lewati buangan ini",
  "coach.pass.reason.noGain": "Mengambil tile ini tidak mempercepat tangan Anda, dan set terbuka membuat tangan lebih kaku.",
  "coach.pass.reason.noUse": "Tile ini tidak melengkapi apa pun di tangan Anda.",
  "coach.draw.headline": "Ambil satu tile dari dinding",
  "coach.draw.reason": "Giliran Anda dimulai dengan mengambil tile. Saat ini {steps}.",
  "coach.draw.note": "Sisa tile di dinding: {count}.",
  "coach.discard.headline": "Buang {tile}",
  "coach.reason.lone-honor": "{tile} berdiri sendiri, dan tile kehormatan tidak bisa membentuk urutan, jadi paling aman dibuang.",
  "coach.reason.lone-terminal": "{tile} adalah tile ujung dan tidak terhubung dengan tile lain, sehingga paling kecil peluangnya membentuk set.",
  "coach.reason.isolated": "{tile} terisolasi sehingga saat ini punya sedikit peluang untuk membentuk set.",
  "coach.reason.run-gap": "{tile} hanya punya tetangga berjarak dua ({runs}), jadi paling lemah di antara sisa tangan Anda.",
  "coach.reason.run-gap.plain": "{tile} hanya punya tetangga berjarak dua, jadi paling lemah di antara sisa tangan Anda.",
  "coach.reason.run-part": "{tile} masih terhubung, tetapi sisa tangan Anda berkembang lebih cepat tanpa tile ini.",
  "coach.reason.pair": "{tile} adalah pasangan, tetapi membuangnya paling sedikit merugikan di posisi ini.",
  "coach.reason.default": "{tile} paling kecil gunanya untuk tangan Anda saat ini.",
  "coach.keep.triplet": "Tiga {tile} sebaiknya dipertahankan karena sudah menjadi satu set penuh.",
  "coach.keep.pair": "Pasangan {tile} sebaiknya dipertahankan karena bisa menjadi pasangan penutup atau berkembang menjadi pong.",
  "coach.keep.run": "{tile} dan {others} lebih baik dipertahankan karena dapat berkembang menjadi beberapa urutan ({runs}).",
  "coach.keep.run.plain": "{tile} dan {others} lebih baik dipertahankan karena masih dapat membentuk urutan.",
  "coach.note.ready": "Setelah buangan ini Anda siap menang, tinggal menunggu {tiles}.",
  "coach.steps.complete": "tangan Anda sudah lengkap",
  "coach.steps.one": "tinggal 1 tile lagi untuk menang",
  "coach.steps.many": "perlu sekitar {count} tile lagi",
  "coach.situation.ended": "Ronde selesai.",
  "coach.situation.claimWaiting": "Menunggu keputusan klaim.",
  "coach.situation.claim": "{player} membuang {tile}. Buangan itu bisa diklaim.",
  "coach.situation.otherTurn": "Sekarang giliran {player}.",
  "coach.situation.yourDraw": "Giliran Anda: ambil tile dari dinding.",
  "coach.situation.yourDiscard": "Giliran Anda: buang satu tile.",

  // ---------- game log ----------
  "log.title": "Catatan permainan",
  "log.empty": "Belum ada langkah.",
  "log.drew.you": "{player} mengambil {tile}. Sisa dinding: {wall}.",
  "log.drew.you.replacement": "{player} mengambil {tile} sebagai pengganti Kong. Sisa dinding: {wall}.",
  "log.drew.other": "{player} mengambil 1 tile.",
  "log.drew.other.replacement": "{player} mengambil 1 tile sebagai pengganti Kong.",
  "log.discarded": "{player} membuang {tile}.",
  "log.claimWindow": "{tile} bisa diklaim.",
  "log.claimDeclared": "{player} menyatakan {claim}.",
  "log.passed": "{player} melewati.",
  "log.meldFormed": "{player} membentuk {meld} dengan {tile}.",
  "log.meldFormed.concealed": "{player} membentuk {meld} dari tangan sendiri.",
  "log.won.selfDraw": "{player} menang dengan tile sendiri: {tile}!",
  "log.won.discard": "{player} menang dari buangan {from}: {tile}!",
  "log.exhaustiveDraw": "Dinding habis. Ronde berakhir seri.",

  // ---------- end of round ----------
  "end.dialog": "Ronde selesai",
  "end.win.you": "Anda menang!",
  "end.win.other": "Ronde selesai",
  "end.draw.title": "Seri",
  "end.draw.body": "Dinding habis sebelum ada yang menang. Tidak ada pemenang di ronde ini.",
  "end.win.selfDraw": "{player} menang dengan {tile} (ambil sendiri).",
  "end.win.fromDiscard": "{player} menang dengan {tile} (dari buangan {from}).",
  "end.noScore": "Versi ini belum menghitung skor: sistem skor regional sengaja belum dipilih.",
  "end.restart": "Ulangi",
  "end.newGame": "Permainan baru",

  // ---------- help ----------
  "help.title": "Cara main (singkat)",
  "help.step1": "Giliran Anda: tekan Ambil tile, lalu klik satu tile untuk dibuang.",
  "help.step2": "Anda menang bila tangan Anda menjadi 4 set + 1 pasangan.",
  "help.step3": "Saat pemain lain membuang, Anda bisa Chow (urutan, hanya dari pemain di kiri Anda), Pong (tiga sama), Kong (empat sama) atau Menang.",
  "help.step4": "Jika dinding habis lebih dulu, ronde berakhir seri.",
  "help.glossaryTitle": "Istilah",

  // ---------- solo ----------
  "solo.title": "Solo",
  "solo.subtitle": "Anda melawan 3 bot deterministik. Seed yang sama selalu membagi tile yang sama.",
  "solo.seed": "Seed",
  "solo.seedAria": "Seed permainan",
  "solo.playSeed": "Main seed ini",
  "solo.newGame": "Permainan baru",
  "solo.replay": "Ulangi",
  "solo.replaySeed": "Ulangi seed ini",
  "solo.footer": "Aturan: {ruleSet} · seed: {seed}",

  // ---------- tutorial ----------
  "tutorial.title": "Belajar Mahjong",
  "tutorial.subtitle": "Tujuh pelajaran singkat. Anda benar-benar bermain: pelatih menjelaskan setiap langkah.",
  "tutorial.restart": "Ulang tutorial dari awal",
  "tutorial.nav": "Daftar pelajaran",
  "tutorial.progress": "Pelajaran {current} dari {total}",
  "tutorial.objective": "Yang dipelajari",
  "tutorial.task": "Tugas",
  "tutorial.coachSays": "Kata pelatih",
  "tutorial.next": "Lanjut: {title}",
  "tutorial.nextLesson": "Pelajaran berikutnya",
  "tutorial.replay": "Ulangi pelajaran",
  "tutorial.back": "Kembali ke daftar pelajaran",
  "tutorial.allDone": "Semua pelajaran selesai. Sekarang coba mode Solo!",
  "tutorial.keepPlaying": "Anda boleh terus bermain di meja ini; pelajaran tidak menghentikan permainan.",
  "tutorial.overview.title": "Tujuh pelajaran",
  "tutorial.overview.subtitle": "Pilih satu pelajaran. Semuanya bisa diulang kapan saja.",
  "tutorial.start": "Mulai pelajaran",
  "tutorial.lessonNumber": "Pelajaran {number}",

  // ---------- online ----------
  "online.title": "Online",
  "online.subtitle": "Server otoritatif menjalankan aturan yang sama. Browser tidak pernah menentukan hasil.",
  "online.status.idle": "Belum terhubung",
  "online.status.connecting": "Menghubungkan...",
  "online.status.reconnecting": "Menyambung kembali...",
  "online.status.online": "Terhubung",
  "online.status.offline": "Terputus",
  "online.status.error": "Gagal terhubung",
  "online.lobby.title": "Buat atau gabung ruangan",
  "online.name": "Nama",
  "online.nameAria": "Nama pemain",
  "online.defaultName": "Pemain",
  "online.createRoom": "Buat ruangan",
  "online.reconnect": "Hubungkan ulang",
  "online.roomCode": "Kode ruangan",
  "online.join": "Gabung",
  "online.lobbyHint": "Bagikan kode ruangan kepada teman. Saat host memulai, kursi kosong akan diisi bot oleh server.",
  "online.roomTitle": "Ruangan",
  "online.seatList": "Kursi di ruangan",
  "online.addBot": "Tambah bot",
  "online.start": "Mulai permainan",
  "online.leave": "Keluar",
  "online.seat": "Kursi {number}",
  "online.seat.empty": "kosong",
  "online.seat.you": "(Anda)",
  "online.badge.host": "host",
  "online.badge.disconnected": "terputus",
  "online.waitingHost": "Menunggu host memulai. Kursi kosong otomatis diisi bot yang dijalankan server.",
  "online.roomExtra": "Ruangan {code}",
  "online.newRound": "Ronde baru",
  "online.leaveRoom": "Keluar ruangan",
  "online.notConnected": "Belum terhubung ke server.",
  "online.badMessage": "Pesan server tidak bisa dibaca.",
  "online.connectFailed": "Tidak bisa terhubung ke server permainan.",
  "online.reconnectFailed": "Koneksi tetap gagal setelah beberapa percobaan. Coba hubungkan ulang.",
  "online.rejected": "Aksi ditolak: {reason}",
  "online.serverError": "Server menolak: {reason}",
  "notice.close": "tutup",

  // ---------- table surface (milestone 3b) ----------
  // ---------- M6 game shell ----------
  "shell.menu": "Menu",
  "shell.menu.open": "Buka menu permainan",
  "shell.menu.close": "Tutup menu",
  "shell.menu.title": "Menu permainan",
  "shell.section.settings": "Pengaturan",
  "shell.stage": "Meja permainan",
  "shell.coach.open": "Tanya pelatih",

  "table.region": "Meja Mahjong",
  "table.center": "Papan tengah",
  "table.compass": "Arah angin di meja",
  "table.actions": "Aksi Anda",
  "table.yourDiscards": "Area buangan Anda",
  "table.latestDiscard": "buangan terakhir",
  "seat.dealerBadge": "bandar",
  "hand.rack": "Rak tile Anda",
  "hand.drawn": "Tile baru diambil",
  "tutorial.details": "Penjelasan lengkap",

  // ---------- pembukaan & preferensi bermain ----------
  "sound.preference": "Suara",
  "opening.preference": "Animasi pembukaan",
  "opening.full": "Lengkap",
  "opening.fast": "Cepat",
  "opening.off": "Mati",
  "opening.skip": "Lewati",
  "opening.title": "Upacara pembukaan Mahjong",
  "opening.stage.settle": "Siapkan meja",
  "opening.stage.shuffle": "Kocok tile",
  "opening.stage.wall": "Susun dinding",
  "opening.stage.dice": "Lempar dadu",
  "opening.stage.deal": "Bagikan tile",
  "opening.stage.ready": "Siap bermain",
  "opening.detail.settle": "Empat kursi, satu meja, 136 tile.",
  "opening.detail.shuffle": "136 tile tertutup dikocok di tengah meja.",
  "opening.detail.wall": "Empat dinding, masing-masing 17 tumpuk × 2 tile.",
  "opening.detail.dice": "Dadu jatuh di {a} dan {b} - bagian dari upacara.",
  "opening.detail.deal": "Tile tertutup dibagikan ke empat kursi.",
  "opening.detail.ready": "Meja siap.",
  "opening.readyDetail": "Bandar: {dealer}. Giliran: {player}.",

  // ---------- portal: shell ----------
  "portal.documentTitle": "kikik.id - main dan belajar",
  "portal.skipToContent": "Lompat ke konten utama",
  "portal.nav.label": "Navigasi kikik.id",
  "portal.nav.home": "Beranda",
  "portal.nav.games": "Game",
  "portal.nav.categories": "Kategori",
  "portal.nav.learn": "Belajar",
  "portal.brand.aria": "kikik.id, kembali ke beranda",
  "portal.search.open": "Cari",
  "portal.search.label": "Cari game, kategori, atau suasana",
  "portal.search.placeholder": "Cari game atau kategori",
  "portal.search.close": "Tutup pencarian",
  "portal.search.results": "{count} hasil untuk “{query}”",
  "portal.search.empty": "Tidak ada yang cocok dengan “{query}”. Kikik baru punya satu game.",
  "portal.search.kind.game": "Game",
  "portal.search.kind.category": "Kategori",
  "portal.search.kind.mood": "Suasana",
  "portal.search.hint": "Tekan Enter untuk membuka hasil pertama.",

  // ---------- portal: status, honestly stated ----------
  "portal.status.playable": "Bisa dimainkan sekarang",
  "portal.status.comingSoon": "Segera hadir",
  "portal.stamp.play": "MAIN",
  "portal.stamp.soon": "SEGERA",
  "portal.badge.oneGame": "1 game",
  "portal.badge.noGame": "Belum ada game",
  "portal.platform.label": "Bisa dimainkan di",
  "portal.platform.web": "Browser",
  "portal.platform.android": "Android",

  // ---------- portal: hero ----------
  "portal.hero.eyebrow": "Judul pertama kami",
  "portal.hero.titleA": "Belum pernah main Mahjong?",
  "portal.hero.titleB": "Mulai dari sini.",
  "portal.hero.body": "Mahjong 4 pemain, dijelaskan dari nol dalam Bahasa Indonesia. Tujuh pelajaran, seorang pelatih yang menjelaskan tiap langkah, lalu meja sungguhan melawan tiga bot.",
  "portal.hero.play": "Main sekarang",
  "portal.hero.how": "Cara main",
  "portal.hero.note": "Gratis, tanpa akun, langsung di browser.",
  "portal.hero.artLabel": "Tujuh tile Mahjong berdiri di atas meja kikik",
  "portal.ladder.label": "Urutan belajar di kikik",
  "portal.ladder.learn.name": "Belajar",
  "portal.ladder.learn.desc": "7 pelajaran + pelatih",
  "portal.ladder.solo.name": "Solo",
  "portal.ladder.solo.desc": "Anda melawan 3 bot",
  "portal.ladder.online.name": "Online",
  "portal.ladder.online.desc": "Satu meja berempat · masih uji coba",

  // ---------- portal: pilih suasana ----------
  "portal.intent.eyebrow": "Mulai dari suasana",
  "portal.intent.title": "Mau main yang seperti apa?",
  "portal.intent.lead": "Pilih satu. Sebuah game hanya diberi tanda kalau memang cocok, jadi beberapa pilihan masih kosong.",
  "portal.intent.empty": "Belum ada game untuk suasana ini. Kikik baru punya satu judul.",
  "portal.intent.showing": "Suasana terpilih: {mood}",
  "portal.intent.clear": "Tampilkan semua lagi",
  "portal.mood.brain-boost": "Asah Otak",
  "portal.mood.play-together": "Main Bareng",
  "portal.mood.quick-play": "Main Cepat",
  "portal.mood.relax": "Santai",
  "portal.mood.challenge": "Tantangan",
  "portal.mood.learn-through-play": "Belajar Sambil Main",
  "portal.mood.timeless-classics": "Klasik Favorit",
  "portal.mood.new-on-kikik": "Baru di Kikik",

  // ---------- portal: pilihan kikik ----------
  "portal.picks.eyebrow": "Pilihan kikik",
  "portal.picks.title": "Satu game, digarap serius.",
  "portal.picks.why.title": "Kenapa Mahjong lebih dulu",
  "portal.picks.why.body": "Mahjong gampang dimengerti, sulit dikuasai, dan hampir tidak pernah diajarkan dalam Bahasa Indonesia untuk pemula. Jadi kami mulai dari situ.",
  "portal.picks.fact1.title": "136 tile, aturan klasik",
  "portal.picks.fact1.body": "Tanpa bunga, tanpa joker. Sistem skor regional sengaja belum dipilih.",
  "portal.picks.fact2.title": "Tujuh pelajaran berurutan",
  "portal.picks.fact2.body": "Dari cara mengambil tile sampai menang dari buangan lawan.",
  "portal.picks.fact3.title": "Bot yang bisa ditebak",
  "portal.picks.fact3.body": "Seed yang sama membagi tile yang sama, jadi satu ronde bisa diulang persis.",
  "portal.picks.cta": "Lihat Kikik Mahjong",

  // ---------- portal: rak kategori ----------
  "portal.worlds.eyebrow": "Rak game",
  "portal.worlds.title": "Dua belas rak. Satu sudah terisi.",
  "portal.worlds.lead": "Rak yang masih kosong tetap kami tampilkan, supaya jelas ke mana kikik akan tumbuh.",
  "portal.category.board-strategy.name": "Papan & Strategi",
  "portal.category.board-strategy.blurb": "Papan, tile, dan rencana yang butuh waktu.",
  "portal.category.puzzle-brain.name": "Puzzle & Asah Otak",
  "portal.category.puzzle-brain.blurb": "Pola, logika, dan momen “oh, iya”.",
  "portal.category.cards-classics.name": "Kartu & Klasik",
  "portal.category.cards-classics.blurb": "Setumpuk kartu dan aturan yang sudah teruji.",
  "portal.category.arcade-casual.name": "Arcade & Kasual",
  "portal.category.arcade-casual.blurb": "Lima menit, satu ronde, langsung jalan.",
  "portal.category.action.name": "Aksi",
  "portal.category.action.blurb": "Refleks cepat dan tekanan yang terus naik.",
  "portal.category.adventure.name": "Petualangan",
  "portal.category.adventure.blurb": "Jalan, temukan sesuatu, lalu pergi lebih jauh.",
  "portal.category.sports-racing.name": "Olahraga & Balapan",
  "portal.category.sports-racing.blurb": "Garis start, garis finis, dan catatan waktu.",
  "portal.category.simulation.name": "Simulasi",
  "portal.category.simulation.blurb": "Atur, jalankan, lihat akibatnya.",
  "portal.category.multiplayer-party.name": "Multiplayer & Party",
  "portal.category.multiplayer-party.blurb": "Satu ruangan, beberapa orang, cukup ramai.",
  "portal.category.music-rhythm.name": "Musik & Ritme",
  "portal.category.music-rhythm.blurb": "Ketukan yang harus Anda ikuti.",
  "portal.category.family.name": "Keluarga",
  "portal.category.family.blurb": "Cukup mudah untuk dimainkan bersama.",
  "portal.category.learn-explore.name": "Belajar & Eksperimen",
  "portal.category.learn-explore.blurb": "Main dulu; sadar sudah belajar belakangan.",

  // ---------- portal: belajar sambil main ----------
  "portal.learn.eyebrow": "Belajar sambil main",
  "portal.learn.title": "Belajar tanpa terasa seperti belajar.",
  "portal.learn.body": "Kikik dibangun untuk orang yang belum pernah mencoba. Aturan dijelaskan saat dibutuhkan, di meja sungguhan, bukan di halaman teori yang panjang.",
  "portal.learn.now.title": "Yang sudah bisa dicoba",
  "portal.learn.now.body": "Mode Belajar di Kikik Mahjong: tujuh pelajaran berurutan, meja yang disiapkan untuk satu keputusan, dan pelatih yang menjelaskan alasannya.",
  "portal.learn.now.cta": "Mulai dari pelajaran 1",
  "portal.learn.next.title": "Arah yang sedang kami siapkan",
  "portal.learn.honest": "Belum satu pun judul edukasi yang dirilis. Ini arah, bukan janji.",
  "portal.learn.topic.science": "Sains",
  "portal.learn.topic.logic": "Logika",
  "portal.learn.topic.math": "Matematika",
  "portal.learn.topic.language": "Bahasa",
  "portal.learn.topic.tech": "Teknologi",
  "portal.learn.topic.simulation": "Simulasi",
  "portal.learn.topic.experiment": "Eksperimen",

  // ---------- portal: berikutnya ----------
  "portal.next.eyebrow": "Berikutnya",
  "portal.next.title": "Ke mana kikik tumbuh",
  "portal.next.lead": "Tanpa tanggal dan tanpa janji. Ini urutan yang masuk akal buat kami.",
  "portal.next.item1.title": "Mahjong di Android",
  "portal.next.item1.body": "Aturan yang sama, engine yang sama, layar sentuh.",
  "portal.next.item2.title": "Meja online untuk umum",
  "portal.next.item2.body": "Servernya sudah jalan untuk pengembangan, belum untuk publik.",
  "portal.next.item3.title": "Rak kedua",
  "portal.next.item3.body": "Kartu & Klasik atau Puzzle & Asah Otak lebih dulu.",
  "portal.next.item4.title": "Judul edukasi pertama",
  "portal.next.item4.body": "Dibangun di atas mode Belajar yang sudah ada.",

  // ---------- portal: footer ----------
  "portal.footer.blurb": "Tempat main dan belajar, dalam Bahasa Indonesia lebih dulu.",
  "portal.footer.honest": "Satu game sudah rilis. Sisanya belum ada, dan kami tidak berpura-pura sebaliknya.",
  "portal.footer.madeIn": "Dibuat di Indonesia",

  // ---------- portal: halaman game ----------
  "portal.game.mahjong.title": "Kikik Mahjong",
  "portal.game.mahjong.tagline": "Mahjong Bahasa Indonesia untuk pemula",
  "portal.game.mahjong.description": "Mahjong klasik empat pemain: 136 tile, tanpa bunga, tanpa joker. Belajar dari nol, main solo melawan tiga bot, lalu duduk di satu meja bersama pemain lain.",
  "portal.entry.eyebrow": "Papan & Strategi · Bisa dimainkan sekarang",
  "portal.entry.back": "Beranda kikik.id",
  "portal.entry.homeAria": "Kembali ke beranda kikik.id",
  "portal.entry.choose": "Pilih cara main",
  "portal.entry.chooseLead": "Ketiganya memakai engine dan aturan yang sama. Kalau ini kali pertama, mulai dari Belajar.",
  "portal.entry.open": "Buka",
  "portal.entry.about.title": "Isi permainannya",
  "portal.entry.rules.title": "Aturan yang dipakai",
  "portal.entry.rules.body": "Empat pemain, 136 tile, chow / pong / kong, dan menang dengan 4 set + 1 pasangan. Sistem skor regional sengaja belum dipilih.",
  "portal.exit.label": "kikik.id",
  "portal.exit.aria": "Keluar dari meja, kembali ke beranda kikik.id",

  // ---------- errors (engine + protocol codes) ----------
  "error.GAME_ENDED": "Ronde sudah selesai. Mulai permainan baru.",
  "error.NOT_YOUR_TURN": "Belum giliran Anda.",
  "error.WRONG_PHASE": "Langkah itu tidak bisa dilakukan sekarang.",
  "error.WALL_EMPTY": "Dinding sudah habis.",
  "error.TILE_NOT_IN_HAND": "Tile itu tidak ada di tangan Anda.",
  "error.NOT_A_WINNING_HAND": "Tangan Anda belum lengkap: butuh 4 set + 1 pasangan.",
  "error.CLAIM_NOT_SUPPORTED": "Klaim tidak tersedia pada aturan ini.",
  "error.NOT_IN_CLAIM_WINDOW": "Tidak ada klaim yang menunggu jawaban Anda.",
  "error.ILLEGAL_CLAIM": "Klaim itu tidak sah untuk tile tersebut.",
  "error.UNKNOWN_PLAYER": "Pemain tidak dikenal.",
  "error.UNKNOWN_ACTION": "Aksi tidak dikenal.",
  "error.BAD_MESSAGE": "Server tidak mengenali pesan itu.",
  "error.UNSUPPORTED_PROTOCOL": "Versi protokol berbeda. Muat ulang halaman.",
  "error.NO_SESSION": "Sesi tidak ditemukan. Hubungkan ulang.",
  "error.ROOM_NOT_FOUND": "Ruangan dengan kode itu tidak ada.",
  "error.ROOM_FULL": "Ruangan sudah penuh.",
  "error.ALREADY_IN_ROOM": "Anda sudah berada di sebuah ruangan.",
  "error.NOT_IN_ROOM": "Anda belum berada di ruangan.",
  "error.NOT_HOST": "Hanya host yang bisa melakukan itu.",
  "error.GAME_ALREADY_STARTED": "Permainan sudah dimulai.",
  "error.GAME_NOT_STARTED": "Permainan belum dimulai.",
  "error.NOT_YOUR_SEAT": "Itu bukan kursi Anda.",
  "error.RESUME_FAILED": "Gagal menyambung kembali ke ruangan sebelumnya.",
} as const;

/** Every string the app can show. English is typed against this list. */
export type StringKey = keyof typeof ID_STRINGS;
